<template>
    <div class="margin-btn">
        <div class="btn-item" @click="showCode">
            <div class="color-red">下载</div>
            <div class="color-red">APP</div>
        </div>
        <div class="btn-item" @click="contactService">
            <div class="color-red">联系</div>
            <div class="color-red">客服</div>
        </div>
        <div class="btn-item" @click="toTop">
            <img class="btn-item-top" src="./../assets/img/top.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "MarginBtn",
        data() {
            return {
                scrollTop: 0
            }
        },
        methods: {
            showCode(){
                window.open('http://yinghua.buy23.cn/api/v1/test?from=singlemessage&isappinstalled=0','_blank')
            },
            contactService(){
                this.$router.push('/contactService')
            },
            toTop(){
                console.log(app.scrollTop);
                this.scrollTop = app.scrollTop;
                this.scrollBody(app.scrollTop)
                /*setTimeout(() => {
                    app.scrollTop = 0;
                }, 0)*/
            },
            scrollBody(){
                app.scrollTop =  app.scrollTop - this.scrollTop/18;
                if(app.scrollTop>0){
                    requestAnimationFrame(this.scrollBody)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .margin-btn{
        position: fixed;
        right: 20px;
        top: 50%;
        .btn-item{
            width: 68px;
            height: 68px;
            margin-bottom: 10px;
            background-color: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column;
            .btn-item-top{
                width: 20px;
                height: 20px;
                object-fit: contain;
            }
        }

        z-index: 5;
    }
</style>
